<template>
  <div>
    <TableWrapper
      :table-columns="rolesColumns"
      table-key="roles"
      :enable-selection="false"
      @editRole="goToEdit"
      @showUsers="showUserRoles"
    />

    <ViewActionButtons :buttons="actionButtons" />

    <CreateEditRole
      :visible="openCreateEditRole"
      :is-modal-edit="isModalEdit"
      :initial-data="initialRoleData"
      @dialogClose="handleDialogClose"
    />
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';

  import TableWrapper from '@/components/TableWrapper.vue';
  import ViewActionButtons from '@/components/ViewActionButtons.vue';
  import { rolesColumns } from '@/config';
  import { rolesApi } from '@/api';
  import CreateEditRole from './CreateEditRole.vue';

  export default {
    name: 'RolesIndex',
    components: {
      TableWrapper,
      ViewActionButtons,
      CreateEditRole,
    },
    data() {
      return {
        rolesColumns,
        openCreateEditRole: false,
        isModalEdit: false,
        initialRoleData: {},
        actionButtons: [
          {
            text: this.$t('roles.create.createRole'),
            type: 'primary',
            permissions: ['rolesManage'],
            action: () => {
              this.openCreateEditRole = true;
            },
          },
        ],
      };
    },
    computed: {
      ...mapGetters(['tableFilters']),
    },
    created() {
      this.parseQueryStringStatus(this.$route.query);
      this.tableRows();
    },
    beforeRouteEnter(to, from, next) {
      next((vm) => {
        if (to.params.roleName) vm.getRole();
      });
    },
    beforeRouteUpdate(to, from, next) {
      this.parseQueryStringStatus(to.query);
      this.tableRows();
      next();
    },
    methods: {
      ...mapActions([
        'updateTableRows',
        'updateTableCount',
        'parseQueryStringStatus',
      ]),
      async tableRows() {
        try {
          const rolesIndexResponse = await rolesApi.index(
            this.tableFilters('roles')
          );
          const rolesCountResponse = await rolesApi.count();
          this.updateTableRows({
            tableKey: 'roles',
            rows: rolesIndexResponse.data,
          });
          this.updateTableCount({
            tableKey: 'roles',
            count: rolesCountResponse.data.count,
          });
        } catch (error) {
          this.$notify({
            showClose: true,
            type: 'error',
            message: error.response.data.error.message,
          });
        }
      },
      async getRole() {
        try {
          const role = await rolesApi.show(this.$route.params.roleName);
          this.initialRoleData = { ...role.data };
          this.isModalEdit = true;
          this.openCreateEditRole = true;
        } catch (error) {
          this.$notify({
            showClose: true,
            type: 'error',
            message: error.response.data.error.message,
          });
          this.$router.push({ name: 'roles' });
        }
      },
      showUserRoles(role) {
        const filterData = {
          role: [
            {
              key: role.name,
              label: role.name,
            },
          ],
        };
        this.$router.push({
          name: 'usersManagement',
          query: {
            filterKey: 'users',
            filterData: JSON.stringify(filterData),
          },
        });
      },
      goToEdit(row) {
        this.$router.push({
          name: 'rolesEdit',
          params: { roleName: row.name },
        });
      },
      handleDialogClose(status) {
        this.openCreateEditRole = false;
        if (status.success) this.tableRows();
        if (this.isModalEdit) {
          this.isModalEdit = false;
          this.$router.push({ name: 'roles' });
        }
      },
    },
  };
</script>
